import React, { useState } from 'react';
import { NavMenu } from '@internal/schema-client';
import { canUseDOM } from '@internal/utils/can-use-dom';
import { Nav } from '@gjensidige/core-navigation';

import { SearchModal } from './modal';

export const SearchButton = (props: NavMenu['search']): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const onToggle = (event: React.MouseEvent | React.KeyboardEvent) => {
    if (event.type === 'click' || (event as React.KeyboardEvent).key === ' ') {
      event.preventDefault();
      setShowModal(!showModal);
    }
  };

  return (
    <>
      <Nav.Search
        href={props.action.href}
        label={props.action.label}
        onClick={onToggle}
        onKeyDown={onToggle}
        role="button"
      />
      {canUseDOM() && (
        <SearchModal
          showModal={showModal}
          onClickModal={() => setShowModal(false)}
          {...props}
        />
      )}
    </>
  );
};
